export default __webpack_public_path__ + "static/triangle_w.5383f27c09114495322239a0a739c119.svg";